<rx-awareness-banner>
	<ng-container [ngSwitch]="isProcedureFlow">
		<span class="rx-awareness-banner-title" *ngSwitchCase="true">{{ 'Awareness.BannerTitleAfterLmr' | translate }}</span>
		<span class="rx-awareness-banner-title" *ngSwitchCase="false">{{ 'Awareness.BannerTitleBeforeGA' | translate }}</span>
	</ng-container>
</rx-awareness-banner>
